import config from 'config';

const sigiraSupplierDev = ['0782847d-e576-51c4-a196-6872a0b3144b'];
const sigiraSupplierStg = ['7f8efe53-a6eb-5ca6-b5c7-151053f90860'];
const sigiraSupplierProd = [''];

export const isSigiraLogin = (supplierId: string): boolean => {
  switch (config.envName) {
    case 'development':
      return sigiraSupplierDev.includes(supplierId);
    case 'staging':
      return sigiraSupplierStg.includes(supplierId);
    case 'production':
      return sigiraSupplierProd.includes(supplierId);
    default:
      return false;
  }
};
